'use client';

import { type FC, type ReactNode } from 'react';

import { SnackbarProvider as NotistackSnackbarProvider } from 'notistack';

import { Notification } from '@/components/SnackbarProvider/components/Notification';

type SnackbarProps = {
  children: ReactNode;
};

export const SnackbarProvider: FC<SnackbarProps> = (props) => {
  const { children } = props;

  return (
    <NotistackSnackbarProvider
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      dense={true}
      Components={{
        default: Notification,
        error: Notification,
        success: Notification,
        warning: Notification,
        info: Notification,
      }}
    >
      {children}
    </NotistackSnackbarProvider>
  );
};
